import {includes} from 'ramda';
import {createSelector} from 'reselect';

import {RoutingType} from 'constants/flow/flowTypes';
import {ApplicationStoreType} from 'reducers';

import {CustomerType} from 'reducers/customer/customerType';
import {PageAppType} from 'reducers/app/pageApp/pageAppType';
import {getSearchParams} from 'selectors/router/router';
import {getSearchMap} from 'libs/router';

/**
 * Returns current page
 * @param {ApplicationStoreType} store - Current store
 * @returns {PageAppType} - Stored app page
 */
export const getCurrentPage = (store: ApplicationStoreType): PageAppType => store.pageApp;

/**
 * Returns page is category
 * @param {PageAppType} - Stored app page
 * @returns {boolean} - page is category
 */
export const isCurrentPageCategory = createSelector(
    getCurrentPage,
    ({page}: PageAppType): boolean => page === 'category',
);

/**
 * Returns page is wishlist
 * @param {PageAppType} - Stored app page
 * @returns {boolean} - page is category
 */
export const isCurrentPageWishlist = createSelector(
    getCurrentPage,
    ({page}: PageAppType): boolean => page === 'wishlist',
);

/**
 * Returns current page
 * @param {ApplicationStoreType} store - Current store
 * @returns {CustomerType} - Stored customer
 */
export const getCustomer = (store: ApplicationStoreType): CustomerType => store.customer;

/**
 * Returns current location
 * @param {ApplicationStoreType} store - Current store
 * @returns {RoutingType} - Stored location
 */
export const getLocation = (store: ApplicationStoreType): RoutingType => store.router;

/**
 * Returns the truth if this page is cart page.
 * @param {ApplicationStoreType} store - Current store
 * @returns {boolean} - Is cart page.
 */
export const isCartPage = (store: ApplicationStoreType): boolean =>
    includes(store.router.location.pathname, ['/checkout/cart', '/checkout/cart/']);

/**
 * Is insurance TYP
 * @param {PageAppType} - Stored app page
 * @returns {boolean} - page is insurance TYP
 */
export const isInsuranceSuccessPage = createSelector(
    getCurrentPage,
    getSearchParams,
    ({page}: PageAppType, search: string): boolean => {
        const searchParams = getSearchMap(search);
        return page === 'successPage' && Boolean(searchParams.insurance);
    },
);
